module.exports = __webpack_public_path__ + "img/refresh-new.702d4996.svg";